import { SVGProps, Ref, forwardRef } from 'react';

export const ImessageGrayscaleSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M12 2.1c-2.917 0-5.715.97-7.778 2.697S1 8.867 1 11.31c.003 1.588.496 3.15 1.433 4.531.936 1.382 2.283 2.537 3.911 3.354-.434.975-1.084 1.89-1.923 2.706a11.75 11.75 0 0 0 4.467-1.764c1.01.251 2.058.38 3.112.381 2.917 0 5.715-.97 7.778-2.697S23 13.751 23 11.31s-1.159-4.785-3.222-6.512S14.918 2.1 12 2.1"
                fill="#919191"
            />
        </g>
    </svg>
));
ImessageGrayscaleSize24Glyph.displayName = 'ImessageGrayscaleSize24Glyph';
